<template lang="pug">
nav.nav-bar.container-fluid
  .d-flex.align-items-center
    .col-auto
      a.brand(@click="goTo('/')")
        img(src='../assets/logo-adherencia.png', alt='Adherencia' class='img-fluid pt-2')
    .col-auto.mr-5.ml-auto.navbar__item.align-self-end
      c-dropdown.account(placement='bottom-end')
        .navbar__item.ml-auto
          a.account(role='button')
            .account__content.text-right.mr-2
              .account__title.text-capitalize
                | {{userinfo.name}} &nbsp;
                br
                small.account__meta.text-capitalize
                  | {{userinfo.profile.name}} &nbsp;
            figure.account__media
              img.avatar(src='../assets/avatar.jpg', alt='')
            .account__after
              font-awesome-icon(icon="angle-down")
        c-dropmenu(slot='content')
          //.- c-dropmenu-item(title="Manual de usuario", href="https://xd.adobe.com/view/88f37891-5e3a-455a-67d9-b382fc7c9142-fec2/?fullscreen", target="_blank")
          //.- c-dropmenu-divider
          c-dropmenu-item(icon='fas fa-unlock-alt', title='Cambiar clave', v-on:click='changePwd()')
          c-dropmenu-item(icon='fas fa-power-off', title='Salir', v-on:click='logOut()')
          c-dropmenu-divider
          .u-text-center
            p.u-text-muted.u-center-block v{{version}}
  
  .d-flex.mt-2.align-items-end
    .col
      ul.nav-menu
        li(v-show="permissions.home")
          router-link(to="/home") Resumen Semanal
        li(v-show="permissions.planificacion_semanal == true && pisopen == true")          
          router-link(to="/planificacion-semanal") Planificación Semanal
        li(v-show="permissions.dialogo_desempeno")
          router-link(to="/dialogo-desempeno/id") DDD
        li(v-show="permissions.confirmacion_procesos")
          router-link(to="/confirmacion-procesos/id") Confirmación de Procesos
        li(v-show="permissions.seguimiento_diario")
          router-link(to="/seguimiento-diario/id") Seguimiento Diario
        li(v-show="permissions.confirmacion_proceso_mensual")
          router-link(to="/confirmacion-procesos-mensual/id") Confirmación de Proceso Mensual
        li(v-show="permissions.historico")
          router-link(to="/historico/id") Histórico
        li(v-show="userinfo.name.toLowerCase().trim() == 'consultor'")
          router-link(to="/consultor/id") Estado General
        //.- li
          //.- router-link(to="#") Historiales
        li.ml-auto.px-5
          span
            i.icon-xs.icon-info.mr-2
            | Ayuda
          ul.drop
            li
              a(href="mailto:soporteadherencia@persis.cl")
                | Contacto técnico
            li  
              a(href="https://xd.adobe.com/view/88f37891-5e3a-455a-67d9-b382fc7c9142-fec2/screen/6d018468-f800-4b47-b43e-5b268fc441ed/Web-1920-35?fullscreen", target="_blank")
                | Manual interactivo
            li
              a(href="./static/resource/ManualAdherencia.pdf", target="_blank")
                | Descargar manual
        li(v-show="userinfo.isAdminOfUsers")
          router-link(to="/administracion/id")
            i.icon-xs.icon-cog.mr-2
            | Administración
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import jsonpck from '../../package.json'
import moment from 'moment'

export default {
  name: 'Navbar',
  data () {
    return {
      userinfo: {
        name: null,
        profile: {
          name: null
        }
      },
      pisopen: null,
      version: null,
      permissions: {
        home: true,
        planificacion_semanal: true,
        dialogo_desempeno: true,
        confirmacion_procesos: true,
        dialogo_desempeno: true,
        seguimiento_diario: true,
        confirmacion_proceso_mensual: true,
        administracion_usuarios: true,
        historico: true
      },
    }
  },
  methods: {
    moment,
    ...mapActions('plan', [
      'planIsOPenByWeek'
    ]),
    goTo (namepath) {
      this.$router.replace({path: namepath})
    },  
    toggleSider () {
      this.$root.siderOpen = !this.$root.siderOpen
    },
    logOut () {
      const vm = this      
      vm.$store.dispatch('auth/logOut').then(() => {        
        vm.$router.replace({path: '/'})        
      })     
    },
    changePwd () {
      this.$router.replace('/change-password')
    },
    _isAdmin () {
      const vm = this
      let admin = vm.userinfo.profile.name == 'admin' ? true : false
      return admin
    },
    _canSee (tab) {
      const vm = this
      for (let p in vm.permissions) {
        vm.permissions[p] = vm.$store.getters['auth/canAccessTab'](p)
      }
    },
    planIsOpen () {
      const vm = this
      vm.planIsOPenByWeek({date: Date.now(), id: vm.userinfo.id}).then(() => {
        vm.pisopen = vm.pisopen === 'hide' ? false : vm.$store.getters['plan/getPlanIsOpen']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    }
  },
  computed: {
    ...mapGetters('plan', {
      plan: 'getPlan'      
    })
  },
  mounted () {
    this.$root.$on('hidePlanification', text => {
      this.pisopen = text
    })
    this.userinfo = this.$store.getters['auth/getUserInfo']
    this.version = jsonpck.version
    this._canSee()
    this.planIsOpen()  
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navbar.vue